import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  registerProposal,
  generatePolicy,
  policyPaper,
  eSewaPayment,
  generateReceipt,
  termInsuranceRequiredDetailsList,
  sunLifeTermInsuranceDetails,
  getTermLifePremium,
  termPolicyIssued,
  PremiumCalculator,
  riderPaper,
  getProposalForEdit,
  GetPreviousPolicyStatusWithDetails,
} from "../api/termLifeApi";

const initialState = {
  detailsList: "",
};

// Create a new Currency

export const fetchPremiumCalculator = createAsyncThunk(
  "termLife/register",
  async (formValue) => {
    const response = await PremiumCalculator(formValue);
    // toastMessage(response.status, response.result);
    return response;
  }
);

export const fetchPreviousPolicyStatusWithDetails = createAsyncThunk(
  "policy/fetchStatusWithDetails",
  async (policyId) => {
    const response = await GetPreviousPolicyStatusWithDetails(policyId);
    return response;
  }
);

export const registerProposalAsync = createAsyncThunk(
  "termLife/register",
  async (formValue) => {
    const response = await registerProposal(formValue);
    // toastMessage(response.status, response.result);
    return response;
  }
);

export const getPDFPolicyNoAsync = createAsyncThunk(
  "termLife/getPDFPolicyNo",
  async (formValue) => {
    const res = await policyPaper(formValue);
    return res;
  }
);

export const getPDFRIderPolicyNoAsync = createAsyncThunk(
  "termLife/getPDFRIderPolicyNoAsync",
  async (params, { rejectWithValue }) => {
    try {
      const res = await riderPaper(params.id, params.rider);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const eSewaPaymentAsync = createAsyncThunk(
  "termLife/register",
  async (formValue) => {
    const response = await eSewaPayment(formValue);
    return response;
  }
);

export const generatePolicyAsync = createAsyncThunk(
  "termLife/GeneratePolicy",
  async (formValue) => {
    const response = await generatePolicy(formValue);
    // toastMessage(response.status, response.result);
    return response;
  }
);

export const policyPaperAsync = createAsyncThunk(
  "termLife/policyPaperAsync",
  async (formValue) => {
    const response = await policyPaper(formValue);
    // toastMessage(response.status, response.result);
    return response;
  }
);

export const generateReceiptAsync = createAsyncThunk(
  "termLife/generateReceiptAsync",
  async (formValue) => {
    const response = await generateReceipt(formValue);
    // toastMessage(response.status, response.result);
    return response;
  }
);

export const termInsuranceRequiredDetailsListAsync = createAsyncThunk(
  "Term insurance Required Details List",
  async (formValue) => {
    const response = await termInsuranceRequiredDetailsList(formValue);
    return response;
  }
);

export const GetSunLifeTermInsuranceDetailsAsync = createAsyncThunk(
  "Policy Paper and Receipt",
  async (formValue) => {
    const response = await sunLifeTermInsuranceDetails(formValue);
    return response;
  }
);

export const getProposalAsync = createAsyncThunk(
  "fetch proposal for edit",
  async (formValue) => {
    const response = await getProposalForEdit(formValue);
    return response;
  }
);

export const apiGetSunLifeTermRateAsync = createAsyncThunk(
  "get TermLife Premium",
  async (formValue) => {
    const response = await getTermLifePremium(formValue);
    return response;
  }
);

export const apiSunLifeTermPolicyIssued = createAsyncThunk(
  "Term policy issued after payment",
  async (formValue) => {
    const response = await termPolicyIssued(formValue);
    return response;
  }
);

const termLifeSlice = createSlice({
  name: "termLife",
  initialState,
  reducers: {},
  extraReducers: {
    [termInsuranceRequiredDetailsListAsync.fulfilled]: (state, { payload }) => {
      return { ...state, detailsList: payload };
    },
  },
});

export const getRequiredTermInsuranceDetailsList = (state) =>
  state.termLife.detailsList;

export default termLifeSlice.reducer;
